import { PageMeta } from "@/components/PageMeta";
import { SectionHeading } from "@/components/SectionHeading";
import { GlassPanel } from "@/components/GlassPanel";
import { CtaLink } from "@/components/Button";
import { solutionAudiences } from "@/content/solutions";
import { routeSeo } from "@/content/seo";

export function SolutionsPage() {
  const seo = routeSeo["/solutions"];
  return (
    <>
      <PageMeta title={seo.title} description={seo.description} path="/solutions" />

      <section className="container page-hero">
        <p className="eyebrow">Solutions</p>
        <h1 className="page-hero-title">Devory for the way your team actually works</h1>
        <p className="page-hero-lede">
          Devory brings visual design, implementation, execution, source control and operational
          management closer together, for a professional engineering team and for someone building
          their first project alike. Here is how that applies to the people who actually use it,
          without claiming a specific productivity number nobody has measured yet.
        </p>
      </section>

      <section className="container section">
        <div className="grid-2">
          {solutionAudiences.map((audience) => (
            <GlassPanel as="article" key={audience.id} className="audience-card">
              <SectionHeading level={3} title={audience.title} lede={audience.summary} />
              <ul className="list-check">
                {audience.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </GlassPanel>
          ))}
        </div>
      </section>

      <section className="container section-tight">
        <GlassPanel className="cta-banner">
          <h2>Not sure which fits your team?</h2>
          <p>
            Tell Devory about your team and what you&rsquo;re trying to solve. A real person will
            respond.
          </p>
          <div className="cta-banner-actions">
            <CtaLink to="/contact" variant="primary">
              Contact Devory
            </CtaLink>
          </div>
        </GlassPanel>
      </section>
    </>
  );
}
